export default __webpack_public_path__ + "static/media/html-css.2e0e0f0d.png";